/* House of Bones 2026 · small helpers on top of Dawn */
(function () {
  var root = document.documentElement;
  var cfg = window.HOB || {};

  /* ---------- Light / dark toggle (dark is the default, set in hob-settings) ---------- */
  var icons = document.querySelector('.header__icons');
  if (icons && !icons.querySelector('[data-hob-theme-toggle]')) {
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'hob-theme-toggle header__icon';
    t.setAttribute('data-hob-theme-toggle', '');
    t.innerHTML = '<svg class="hob-moon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/></svg>' +
      '<svg class="hob-sun" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/></svg>';
    var search = icons.querySelector('.header__search, details-modal');
    if (search && search.nextSibling) icons.insertBefore(t, search.nextSibling);
    else icons.insertBefore(t, icons.firstChild);
  }
  function syncToggles() {
    var dark = root.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-hob-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? (cfg.tLight || 'Switch to light mode') : (cfg.tDark || 'Switch to dark mode'));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hob-theme-toggle]');
    if (!b) return;
    var dark = root.getAttribute('data-theme') !== 'dark';
    if (dark) root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    try { localStorage.setItem('hob-theme', dark ? 'dark' : 'light'); } catch (err) {}
    syncToggles();
  });
  syncToggles();

  /* Free-shipping bars now live in hob-header.js (per country, header strip + cart). */

  /* ---------- Popular searches in the search overlay ---------- */
  var popular = (cfg.popular || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
  function setupSearch(modal) {
    var input = modal.querySelector('input[type="search"]');
    var content = modal.querySelector('.search-modal__content');
    if (!input || !content || content.querySelector('.hob-popular') || !popular.length) return;
    var box = document.createElement('div');
    box.className = 'hob-popular';
    box.innerHTML = '<span class="hob-eyebrow hob-muted">' + (cfg.tPopular || 'Popular right now') + '</span><div class="hob-popular__chips"></div>';
    var chips = box.querySelector('.hob-popular__chips');
    popular.forEach(function (term) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'hob-chip';
      c.textContent = term;
      c.addEventListener('click', function () {
        input.value = term;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      chips.appendChild(c);
    });
    content.appendChild(box);
    var sync = function () { box.hidden = input.value.trim().length > 0; };
    input.addEventListener('input', sync);
    sync();
  }
  document.querySelectorAll('details-modal.header__search, .header__search').forEach(setupSearch);

  /* ---------- Size stock line on the product page ---------- */
  document.querySelectorAll('[data-hob-size-stock]').forEach(function (el) {
    var data = {};
    try { data = JSON.parse(el.querySelector('script').textContent); } catch (e) { return; }
    var low = data.low || 2;
    var out = el.querySelector('[data-hob-size-stock-text]');
    function show(id) {
      var v = data.variants[String(id)];
      if (!v || !out) return;
      out.className = 'hob-size-stock';
      if (v.q <= 0 && !v.c) { out.textContent = (cfg.tSoldIn || 'Sold out in {size}').replace('{size}', v.t); out.classList.add('hob-size-stock--out'); }
      else if (v.m && v.q <= low) { out.textContent = (v.q === 1 ? (cfg.tOne || 'Only 1 left in {size}') : (cfg.tFew || 'Only {n} left in {size}')).replace('{n}', v.q).replace('{size}', v.t); out.classList.add('hob-size-stock--low'); }
      else { out.textContent = (cfg.tInStock || 'In stock in {size}').replace('{size}', v.t); out.classList.add('hob-size-stock--ok'); }
    }
    if (data.single) return;
    show(data.current);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) show(event.data.variant.id);
      });
    }
  });

  /* ---------- Sticky add-to-cart on mobile ---------- */
  var sticky = document.querySelector('.hob-sticky-atc');
  var realBtn = document.querySelector('.product-form__submit');
  if (sticky && realBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(realBtn);
    sticky.querySelector('[data-hob-sticky-buy]').addEventListener('click', function () {
      if (realBtn.disabled) { realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      realBtn.click();
    });
  }
})();
